import SubjectAPI from '@/apis/business/common/subject-api.js'

export default {
  namespaced: true,
  state: {
    subjects: []
  },

  getters: {
    getSubjects (state) {
      return state.subjects
    }

  },

  mutations: {
    setSubjects (state, subjects) {
      state.subjects = subjects
    }

  },

  actions: {
    // getGrade (context, gradeID) {
    //   context.commit('setGrade', gradeID)
    //   const result = context.getters.getClassRoom
    //   return new Promise((resolve, reject) => {
    //     resolve(!!result)
    //   })
    // },

    getSubjects (context, params) {
      return new Promise((resolve, reject) => {
        SubjectAPI.getAsync('', params).then(res => {
          context.commit('setSubjects', res.Data.PageData)
          resolve(true)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}
